import type { Column } from '@/components/ui/DataTable'
import {
  favoriteColumn,
  sourceLinkColumn,
  statusColumn,
  tagsColumn,
} from '@/components/review/columns'
import { PreviouslyRejectedFlag } from '@/components/review/VerdictHistory'
import type { PartnerFact } from '@/types'

export function buildColumns({
  onFavorite,
}: {
  onFavorite: (id: string, favorite: boolean) => void
}): Column<PartnerFact>[] {
  return [
    favoriteColumn<PartnerFact>(onFavorite),
    {
      key: 'label',
      header: 'Fact',
      width: '220px',
      sortBy: (f) => f.label,
      render: (f) => (
        <span className="flex flex-col gap-1">
          <span className="font-head text-[13px] font-semibold">{f.label}</span>
          {f.previouslyRejected && <PreviouslyRejectedFlag compact />}
        </span>
      ),
    },
    {
      key: 'value',
      header: 'Value',
      sortBy: (f) => f.value,
      render: (f) => <span className="block max-w-[60ch] text-[13px] leading-5">{f.value}</span>,
    },
    sourceLinkColumn<PartnerFact>((f) => f.sourceUrl, { showPath: true, header: 'Page' }),
    tagsColumn<PartnerFact>(2, '140px'),
    statusColumn<PartnerFact>(),
  ]
}
